'use client';

import type { Place } from '@/types';
import { Carousel } from '@/ui';
import { basisOptions } from '@/ui/block/carousel';
import { columnsClassName } from '@/ui/server';
import clsx from 'clsx';

import { useEvents } from '@/lib/hooks/use-events';

import { EventCard } from './event-card';
import { EventCardLg } from './event-card-lg';

export function EventSearchCarousel({
  cardSize,
  placesData,
  eventsData: { events },
}: {
  cardSize: 'lg' | 'sm';
  placesData: Place[] | undefined;
  eventsData: ReturnType<typeof useEvents>;
}) {
  return (
    <Carousel
      layout="padded"
      hideButtons
      classNames={{
        carouselItem: clsx(basisOptions[cardSize === 'lg' ? 1 : 4], columnsClassName),
      }}
      items={events?.map((event) => {
        const place = placesData?.find((place) => place.id === event._referencedBy[0]);

        if (cardSize === 'lg') {
          return <EventCardLg event={event} place={place as Place} key={event.id} />;
        }

        return <EventCard dateFormat="EEE do MMM" size="lg" key={event.id} place={place as Place} {...event} />;
      })}
    />
  );
}
